import React, { useState, useEffect } from "react";
import ProductsTemplate from "../ProductsBanner";
import ProductsFeatureTemplate from "../ProductsFeatureTemplate";
import { justifyIndoorProductName } from "../../../../../utils";

function importMediaFiles(r) {
    return r.keys().map(r);
}



const IndoorProducts = props => {
    let productsName = justifyIndoorProductName(window.location.pathname.split('/').pop());
    if (productsName === 'Wibox') {
        productsName = "WiBox";
    };
    const [name, setName] = useState(undefined);
    const [image, setImage] = useState(undefined);
    const [featureImg, setFeatureImage] = useState(undefined);

    const icons = importMediaFiles(
        require.context(
            "../../../../../images/products/icon/canvas icon",
            false,
            /\.(png|jpe?g|svg)$/
        )
    );

    let feature = icons.map((i, n) => {
        let title = `WiCanvasIndoor-feature-txt${n + 1}`;
        let message = `${name}-feature${n + 1}`;
        let obj = { icon: i, title, message }
        return obj
    })

    if (name === "WiBox") {
        feature = [
            {
                icon: icons[1],
                title: "WiCanvasIndoor-feature-txt2",
                message: "WiBox-feature1"
            },
            {
                icon: icons[3],
                title: "WiCanvasIndoor-feature-txt4",
                message: "WiBox-feature2"
            },
            {
                icon: icons[4],
                title: "WiCanvasIndoor-feature-txt5",
                message: "WiBox-feature3"
            },
            {
                icon: icons[5],
                title: "WiCanvasIndoor-feature-txt6",
                message: "WiBox-feature4"
            }
        ]
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        setName(productsName);
        setImage(require(`../../../../../images/products/banner/${productsName}.jpg`));
        setFeatureImage(productsName);
        // setFeatureImage(require(`../../../../../images/products/spec/${productsName}.jpg`));
        return () => window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <ProductsTemplate image={image} />
            <ProductsFeatureTemplate
                image={featureImg}
                title={name}
                feature={feature}
            />
        </div>
    );
}

export default IndoorProducts;
